/* eslint-disable */
import React, { useState, useEffect } from 'react';
import { Row, Col, Card, Statistic, Table, Tag, Typography, Button, Spin, Progress } from 'antd';
import {
  FileTextOutlined,
  ShopOutlined,
  TeamOutlined,
  SendOutlined,
  ReloadOutlined,
  CheckCircleOutlined
} from '@ant-design/icons';
import axios from 'axios';
import { getAuthHeaders } from './jobManagementUtils';
import './JobManagement.css';

const { Title, Text } = Typography;

function JobOverviewDashboard(props) {
  const [loading, setLoading] = useState(false);
  const [metrics, setMetrics] = useState({
    total_posts: 0,
    active_posts: 0,
    total_employers: 0,
    total_seekers: 0,
    total_applications: 0,
    pending_applications: 0,
    recent_applications: []
  });

  const fetchOverview = async () => {
    setLoading(true);
    try {
      const res = await axios.post(
        (props.app_hostname || '') + '/api/account/management/jobs/overview',
        {},
        { headers: getAuthHeaders(props.permitdata?.token) }
      );
      if (res.data && res.data.status === 'Success' && res.data.data) {
        setMetrics(res.data.data);
      }
    } catch (err) {
      // ignore
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchOverview();
  }, []);

  const recentColumns = [
    {
      title: 'ผู้สมัคร',
      dataIndex: 'applicant_name',
      key: 'applicant_name',
      render: (name, record) => (
        <div>
          <span style={{ fontWeight: 600 }}>{name}</span>
          <div style={{ fontSize: 12, color: '#8c8c8c' }}>{record.applicant_phone}</div>
        </div>
      ),
    },
    {
      title: 'ตำแหน่งงานที่สมัคร',
      dataIndex: 'job_title',
      key: 'job_title',
      render: (title, record) => (
        <div>
          <span style={{ color: '#1890ff', fontWeight: 500 }}>{title || '-'}</span>
          <div style={{ fontSize: 12, color: '#8c8c8c' }}>{record.company_name || '-'}</div>
        </div>
      ),
    },
    {
      title: 'เงินเดือนที่คาดหวัง',
      dataIndex: 'expected_salary',
      key: 'expected_salary',
      render: (salary) => salary > 0 ? `${salary.toLocaleString()} บาท` : 'ตามตกลง',
    },
    {
      title: 'สถานะ',
      dataIndex: 'status',
      key: 'status',
      render: (status) => {
        if (status === 'accepted') return <Tag color='success'>ผ่านการคัดเลือก</Tag>;
        if (status === 'interview') return <Tag color='processing'>นัดสัมภาษณ์</Tag>;
        if (status === 'rejected') return <Tag color='error'>ไม่ผ่าน</Tag>;
        return <Tag color='warning'>รอพิจารณา</Tag>;
      },
    },
    {
      title: 'วันที่สมัคร',
      dataIndex: 'created_at',
      key: 'created_at',
    },
  ];

  return (
    <div className='job-management-container'>
      <div className='job-management-header'>
        <div>
          <h2>📊 สถิติภาพรวมระบบหางาน (Jobs Intelligence Dashboard)</h2>
          <Text type='secondary'>
            ข้อมูลสถิติจริงจากฐานข้อมูล MSSQL เชื่อมโยงประกาศงาน สถานประกอบการ และผู้สมัคร
          </Text>
        </div>
        <Button icon={<ReloadOutlined />} onClick={fetchOverview} loading={loading}>
          รีเฟรชสถิติ
        </Button>
      </div>

      <Spin spinning={loading}>
        <Row gutter={[16, 16]}>
          <Col xs={24} sm={12} lg={6}>
            <Card className='job-metric-card'>
              <Statistic
                title='ประกาศรับสมัครงานทั้งหมด'
                value={metrics.total_posts}
                prefix={<FileTextOutlined style={{ color: '#1890ff' }} />}
                suffix='ตำแหน่ง'
              />
              <div style={{ marginTop: 8, fontSize: 12, color: '#52c41a' }}>
                เปิดรับสมัครอยู่ (Active): {metrics.active_posts}
              </div>
            </Card>
          </Col>

          <Col xs={24} sm={12} lg={6}>
            <Card className='job-metric-card'>
              <Statistic
                title='สถานประกอบการ & ร้านค้า'
                value={metrics.total_employers}
                prefix={<ShopOutlined style={{ color: '#52c41a' }} />}
                suffix='แห่ง'
              />
              <div style={{ marginTop: 8, fontSize: 12, color: '#8c8c8c' }}>
                ดึงจากฐานข้อมูลร้านค้าจริงทั้งหมด
              </div>
            </Card>
          </Col>

          <Col xs={24} sm={12} lg={6}>
            <Card className='job-metric-card'>
              <Statistic
                title='ผู้สมัครงานลงทะเบียน'
                value={metrics.total_seekers}
                prefix={<TeamOutlined style={{ color: '#722ed1' }} />}
                suffix='คน'
              />
              <div style={{ marginTop: 8, fontSize: 12, color: '#8c8c8c' }}>
                บัญชีผู้หางานในระบบ
              </div>
            </Card>
          </Col>

          <Col xs={24} sm={12} lg={6}>
            <Card className='job-metric-card'>
              <Statistic
                title='ใบสมัครงานทั้งหมด'
                value={metrics.total_applications}
                prefix={<SendOutlined style={{ color: '#fa8c16' }} />}
                suffix='ฉบับ'
              />
              <div style={{ marginTop: 8, fontSize: 12, color: '#faad14' }}>
                รอการพิจารณา: {metrics.pending_applications}
              </div>
            </Card>
          </Col>
        </Row>

        <Row gutter={[16, 16]} style={{ marginTop: 24 }}>
          <Col xs={24} lg={16}>
            <Card title='📬 ใบสมัครงานล่าสุด (Live Applications Feed)' className='job-management-card'>
              <Table
                columns={recentColumns}
                dataSource={metrics.recent_applications || []}
                rowKey='id'
                pagination={false}
                locale={{ emptyText: 'ยังไม่มีใบสมัครงานเข้ามาในระบบ' }}
              />
            </Card>
          </Col>

          <Col xs={24} lg={8}>
            <Card title='🎯 อัตราส่วนความสมบูรณ์ของระบบ' className='job-management-card'>
              <div style={{ marginBottom: 16 }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 4 }}>
                  <Text>สถานประกอบการที่ลงทะเบียน</Text>
                  <Text strong>{metrics.total_employers > 0 ? '100%' : '0%'}</Text>
                </div>
                <Progress percent={metrics.total_employers > 0 ? 100 : 0} strokeColor='#52c41a' />
              </div>

              <div style={{ marginBottom: 16 }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 4 }}>
                  <Text>ประกาศงานที่เปิดรับ (Active Rate)</Text>
                  <Text strong>
                    {metrics.total_posts > 0
                      ? `${Math.round((metrics.active_posts / metrics.total_posts) * 100)}%`
                      : '0%'}
                  </Text>
                </div>
                <Progress
                  percent={
                    metrics.total_posts > 0
                      ? Math.round((metrics.active_posts / metrics.total_posts) * 100)
                      : 0
                  }
                  strokeColor='#1890ff'
                />
              </div>

              <div>
                <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 4 }}>
                  <Text>การประมวลผลใบสมัคร (Processed)</Text>
                  <Text strong>
                    {metrics.total_applications > 0
                      ? `${Math.round(((metrics.total_applications - metrics.pending_applications) / metrics.total_applications) * 100)}%`
                      : '100%'}
                  </Text>
                </div>
                <Progress
                  percent={
                    metrics.total_applications > 0
                      ? Math.round(((metrics.total_applications - metrics.pending_applications) / metrics.total_applications) * 100)
                      : 100
                  }
                  strokeColor='#722ed1'
                />
              </div>
            </Card>
          </Col>
        </Row>
      </Spin>
    </div>
  );
}

export default JobOverviewDashboard;
